import { render, staticRenderFns } from "./GiftHouse.vue?vue&type=template&id=9ab24104"
import script from "./GiftHouse.vue?vue&type=script&lang=js"
export * from "./GiftHouse.vue?vue&type=script&lang=js"
import style0 from "./GiftHouse.vue?vue&type=style&index=0&id=9ab24104&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports